import React, { useRef, useState } from 'react'
import classes from '@src/styles/JobTypes.module.css'
import { MdArrowForward, MdArrowBack } from 'react-icons/md'
import job1 from '@src/assets/jobs/job-1.jpg'
import job2 from '@src/assets/jobs/job-2.jpg'
// import job3 from '@src/assets/jobs/job-3.jpg'
import job4 from '@src/assets/jobs/job-4.jpg'
import { useRouter } from 'next/router'
import { segmentTrack } from '@src/functions/segment'
import queryString from 'query-string'
import { withAttribution } from '@src/functions/attribution'

const jobs = [
  {
    id: 1,
    name: 'Waste Removal',
    date: 'Thursday 14 Jul',
    location: 'San Francisco 94122',
    price: '$104.00',
    image: job1,
  },
  {
    id: 2,
    name: 'Dumpster Rental',
    date: 'Thursday 17 Sept',
    location: 'San Francisco 94122',
    price: '$104.00',
    image: job2,
  },
  {
    id: 3,
    name: 'Cardboard Removal',
    date: 'Friday 17 Dec',
    location: 'San Francisco 94122',
    price: '$104.00',
    image: job4,
  },
  {
    id: 4,
    name: 'Waste Removal',
    date: 'Monday 14 July',
    location: 'San Jose 94122',
    price: '$104.00',
    image: job1,
  },
  {
    id: 5,
    name: 'Cardboard Removal',
    date: 'Friday 17 Dec',
    location: 'San Francisco 94122',
    price: '$124.00',
    image: job4,
  },
  {
    id: 6,
    name: 'Waste Removal',
    date: 'Monday 14 July',
    location: 'San Jose 94122',
    price: '$134.00',
    image: job1,
  },
]

const SCROLL_AMOUNT = 500

function JobTypes() {
  const scrollRef = useRef<any>(null)
  const [scrollX, setScrollX] = useState<number>(0)
  const [scrollEnd, setScrollEnd] = useState<boolean>(false)
  const history = useRouter()

  // Slide click
  const slide = (shift: number) => {
    scrollRef.current.scrollLeft += shift
    setScrollX(scrollX + shift)

    if (
      Math.floor(scrollRef.current.scrollWidth - scrollRef.current.scrollLeft) <=
      scrollRef.current.offsetWidth
    ) {
      setScrollEnd(true)
    } else {
      setScrollEnd(false)
    }
  }

  const scrollCheck = () => {
    setScrollX(scrollRef.current.scrollLeft)
    if (
      Math.floor(scrollRef.current.scrollWidth - scrollRef.current.scrollLeft) <=
      scrollRef.current.offsetWidth
    ) {
      setScrollEnd(true)
    } else {
      setScrollEnd(false)
    }
  }

  const handleButtonClick = (userType: string) => {
    // eslint-disable-next-line no-console
    console.log('handleButtonClick : userType', userType)
    // dispatch({ type: 'SET_TEMP_USER', userType })
    history.push(
      withAttribution(
        `${process.env.NEXT_PUBLIC_REDIRECT_URL}?`.concat(
          queryString.stringify({
            login: '1',
          }),
        ),
      ),
    )
    segmentTrack('User Clicks Register - Provider Portal', { userType })
  }

  return (
    <section className={classes.container}>
      <div className={classes.mainContent}>
        <h2 className={classes.heading}>Sign Up and Claim Jobs Like These</h2>
        <div className={classes.cardContainer} ref={scrollRef} onScroll={scrollCheck}>
          {jobs.map((job) => (
            <div className={classes.card} key={job.id}>
              <img alt='' className={classes.cardImage} src={job.image.src} />
              <div className={classes.cardContent}>
                <h5 className={classes.cardTitle}>{job.name}</h5>
                <p className={classes.cardItem}>{job.date}</p>
                <p className={classes.cardItem}>{job.location}</p>
              </div>
              <div className={classes.divider} style={{ width: '100%' }} />
              <div className={classes.cardBottom}>
                <span className={classes.price}>{job.price}</span>
                <button
                  className={classes.primaryButton}
                  onClick={() => handleButtonClick('provider')}
                >
                  Claim Task
                </button>
              </div>
            </div>
          ))}
        </div>
        <div className={classes.buttonContainer}>
          <button
            className={classes.secondaryButton}
            onClick={() => scrollX !== 0 && slide(-SCROLL_AMOUNT)}
          >
            <MdArrowBack />
          </button>
          <button
            className={classes.secondaryButton}
            onClick={() => !scrollEnd && slide(+SCROLL_AMOUNT)}
          >
            <MdArrowForward />
          </button>
        </div>
      </div>
    </section>
  )
}

export default JobTypes
